import styled from 'styled-components';

interface StyledNavListItemProps {
  listStyleType?: CSSStyleDeclaration['listStyleType'];
}

export const StyledNavListItem = styled.li<StyledNavListItemProps>`
  list-style-type: ${({ listStyleType }) => listStyleType || 'none'};
`;
